import { render, staticRenderFns } from "./biller-transaction-summary.vue?vue&type=template&id=c2453daa&scoped=true&"
import script from "./biller-transaction-summary.vue?vue&type=script&lang=js&"
export * from "./biller-transaction-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2453daa",
  null
  
)

export default component.exports